import { CONFIG } from '../config';

export class ScoreManager {
    private currentTime: number;
    private highScore: number;
    private scoreMult: number;
    private bonusPoints: number;
    private comboMultiplier: number;

    constructor() {
        this.currentTime = 0;
        this.highScore = this.loadHighScore();
        this.scoreMult = 1.0;
        this.bonusPoints = 0;
        this.comboMultiplier = 1.0;
    }

    setScoreMultiplier(mult: number): void {
        this.scoreMult = mult;
    }

    reset(): void {
        this.currentTime = 0;
        this.bonusPoints = 0;
        this.comboMultiplier = 1.0;
    }

    update(deltaTime: number): void {
        this.currentTime += deltaTime;
    }

    addBonusTime(bonus: number): void {
        this.currentTime += bonus;
    }

    /**
     * 보너스 점수 추가 (Near Miss 등)
     */
    addBonusPoints(points: number): void {
        this.bonusPoints += points;
    }

    /**
     * 콤보 배율 설정
     */
    setComboMultiplier(mult: number): void {
        this.comboMultiplier = mult;
    }

    getTime(): number {
        return this.currentTime;
    }

    getScore(): number {
        const timeScore = Math.floor(this.currentTime * this.scoreMult);
        const bonusScore = Math.floor(this.bonusPoints * this.comboMultiplier);
        return timeScore + bonusScore;
    }

    getBonusPoints(): number {
        return this.bonusPoints;
    }

    getFormattedTime(): string {
        const timeScore = Math.floor(this.currentTime * 10 * this.scoreMult);
        const bonusScore = Math.floor(this.bonusPoints * this.comboMultiplier);
        return (timeScore + bonusScore).toString();
    }

    isNewHighScore(): boolean {
        return this.getScore() > this.highScore;
    }

    saveHighScore(): void {
        const score = this.getScore();
        if (score > this.highScore) {
            this.highScore = score;
            try {
                localStorage.setItem(CONFIG.SCORE.STORAGE_KEY, this.highScore.toString());
            } catch (e) {
                console.warn('Could not save high score to localStorage:', e);
            }
        }
    }

    loadHighScore(): number {
        try {
            const saved = localStorage.getItem(CONFIG.SCORE.STORAGE_KEY);
            return saved ? parseInt(saved, 10) : 0;
        } catch (e) {
            console.warn('Could not load high score from localStorage:', e);
            return 0;
        }
    }

    getHighScore(): number {
        return this.highScore;
    }

    getFormattedHighScore(): string {
        return (this.highScore * 10).toString();
    }

    getRawTime(): number {
        return this.currentTime;
    }
}
